export default __webpack_public_path__ + "static/media/user.ba422ca1.png";